<template>
    <div class="register__errors" v-bind:class="{ 'register__errors--visible': $store.state.errors }">
        <div class="register__errors-inner">
            <div class="alert alert-error">
                <h4>Oops! Something went wrong.</h4>
                <ul class="alert-error__errors">
                    <li class="alert-error__error" v-for="( error, error_index ) in $store.state.errors" v-bind:key="error_index">{{ error }}</li>
                </ul>
            </div>
            <button type="button" v-on:click="$store.dispatch( 'clear_screen' );" class="btn btn-primary w-100">Okay, got it</button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "DVCARegisterErrors"
    }
</script>
